//Icons
import IconBase from './IconBase.vue';

export default {
    components: {
        IconBase,
    },
    props: {
        viewBox: {
            type: String,
            default: '0 0 18 18',
        },
        iconName: {
            type: String,
            default: 'box',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
    },
};
